import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { EntriModule } from '../../ModalsExtensions';
export const entriConnectAction = async _ref => {
  let domainName = _ref.domainName,
    msid = _ref.msid,
    siteName = _ref.siteName,
    overrideEntriEligibility = _ref.overrideEntriEligibility,
    isNonWixEditorSite = _ref.isNonWixEditorSite,
    fullPage = _ref.fullPage,
    t = _ref.t;
  const _getPremiumEssentials = getPremiumEssentials(),
    httpClient = _getPremiumEssentials.httpClient;
  const _DomainsApiClient$que = DomainsApiClient.queries({
      httpClient: httpClient
    }),
    domainsLogger = _DomainsApiClient$que.domainsLogger;
  domainsLogger({
    entity: 'useConnectAction',
    type: 'info',
    metadata: {
      domainName
    }
  });
  try {
    const result = await EntriModule.SDK.startEntriFlow({
      domain: domainName,
      siteName,
      metaSiteId: msid,
      // TODO: add enabledBySpec should be taken from the host app
      enabledBySpec: 'specs.premium.domain.enableEntriInConcierge',
      disablePointing: isNonWixEditorSite,
      overrideEntriEligibility,
      fullPage,
      t
    });
    return result;
  } catch (e) {
    domainsLogger({
      entity: 'entriConnectAction',
      type: 'error',
      metadata: {
        domainName
      },
      error: e,
      message: 'Error in connectAction',
      stack: e == null ? void 0 : e.stack
    });
    throw e;
  }
};
//# sourceMappingURL=entriConnectAction.js.map